import React from 'react';
import ChartTitle from '../ChartTitle';
import {
  Section,
  Header,
  Controls,
  InlineControl,
  LabeledControl,
  TextFormat,
  ToggleGroup,
  ToggleOption,
  Selection,
  SubHeader,
  BackgroundColorControl,
} from '../../../reporting/sidebar/components';

function MainConfig() {
  return (
    <Section defaultOpen>
      <Header>Chart</Header>
      <ChartTitle />
      <SubHeader>Style</SubHeader>
      <Controls>
        <LabeledControl title='Trendline' alignTop>
          <ToggleGroup configurationKey='curve'>
            <ToggleOption value='linear'>
              <i className='fa-solid fa-wave-triangle' /> Linear
            </ToggleOption>
            <ToggleOption value='cardinal'>
              <i className='fa-solid fa-wave-sine' /> Smooth
            </ToggleOption>
          </ToggleGroup>
        </LabeledControl>

        <BackgroundColorControl />

        <LabeledControl title='Data counts'>
          <Selection
            configurationKey='showLabels'
            options={[
              ['On', true],
              ['Off', false],
            ]}
          />
        </LabeledControl>

        <LabeledControl title='Plot nulls'>
          <Selection
            configurationKey='plotNulls'
            options={[
              ['On', true],
              ['Off', false],
            ]}
          />
        </LabeledControl>
        <LabeledControl title='Data labels' />
        <InlineControl>
          <TextFormat
            configurationKey='dataLabelFormat'
            defaultSize={12}
            defaultColor='black'
            defaultFontWeight='normal'
            defaultFontStyle='normal'
          />
        </InlineControl>
      </Controls>
    </Section>
  );
}

export default MainConfig;
